import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import { 
  Brain, 
  Users, 
  UserCircle, 
  Database,
  BookOpen,
  Building2,
  Network,
  GraduationCap
} from 'lucide-react';

function Dashboard() {
  const tools = [
    {
      title: "My Skills Profile",
      description: "Document your skills, assets, relationships, and knowledge areas to create a comprehensive profile of your capabilities.",
      path: "/my-skills",
      icon: Brain
    },
    {
      title: "Skills Exchange Network",
      description: "Connect with community members to share skills and knowledge, building stronger local networks through mutual aid.",
      path: "/skills-exchange",
      icon: Network
    },
    {
      title: "Consumer Profile",
      description: "Build your complete consumer profile with personal information, health details, and preferences for better service.",
      path: "/consumers",
      icon: UserCircle
    },
    {
      title: "Peer Support Network",
      description: "Connect with Peer Support groups in your area for support, services, and collaboration.",
      path: "/peer-support-groups",
      icon: Building2
    },
    {
      title: "Education & Training",
      description: "Access educational articles and training to enhance your skills and knowledge.",
      path: "/articles",
      icon: GraduationCap
    },
    {
      title: "Resource Directory",
      description: "Explore our comprehensive directory of community resources, services, and support programs.",
      path: "/resources",
      icon: Database
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-4">Welcome to CILxChange</h1>
        <p className="text-gray-600 max-w-3xl">
          Access tools and resources to build your skills profile, connect with community members,
          and manage your personal information. Together, we're building a stronger, more connected
          community of support and mutual aid.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {tools.map((tool) => (
          <div key={tool.title} className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow p-6">
            <div className="flex justify-between items-start mb-4">
              <Link 
                to={tool.path}
                className="text-xl font-semibold text-blue-600 hover:text-blue-800"
              >
                {tool.title}
              </Link>
              <tool.icon className="h-6 w-6 text-blue-500" />
            </div>
            
            <p className="text-gray-600 mb-4">{tool.description}</p>
            
            <Link 
              to={tool.path}
              className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800"
            >
              Access Tool
              <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;